import React, { useState, useContext } from "react";
import {
  Container,
  TextField,
  Button,
  Typography,
  Box,
  IconButton,
  InputAdornment
} from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { useLocation, useNavigate } from "react-router-dom";
import { AppContext } from "../context/AppContext";

const UpdatePasswordPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { accessToken } = useContext(AppContext);
  const email = location.state?.email || "";

  const [form, setForm] = useState({ new_password: "", confirm_password: "" });
  const [showPassword1, setShowPassword1] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const submit = async (e) => {
    e.preventDefault();
    setError("");

    if (!form.new_password || !form.confirm_password) {
      setError("Todos los campos son obligatorios.");
      return;
    }

    if (form.new_password !== form.confirm_password) {
      setError("Las contraseñas no coinciden.");
      return;
    }

    if (!accessToken) {
      setError("No se encontró el token de autenticación.");
      return;
    }

    try {
      const response = await fetch("/sistema/update-password/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`
        },
        body: JSON.stringify({
          email: email,
          nueva: form.new_password
        })
      });

      const data = await response.json();

      if (response.ok) {
        navigate("/login");
      } else {
        setError(data.error || "Error al actualizar la contraseña.");
      }
    } catch {
      setError("Error de conexión con el servidor.");
    }
  };

  return (
    <div className="login-container">
      <div className="overlay">
        <Container maxWidth="xs" className="login-form">
          <Typography variant="h5" align="center" gutterBottom className="login-title">
            Actualizar Contraseña
          </Typography>

          {error && <Typography className="error-message">{error}</Typography>}

          <form onSubmit={submit}>
            <TextField
              label="Nueva contraseña"
              type={showPassword1 ? "text" : "password"}
              fullWidth
              margin="normal"
              name="new_password"
              value={form.new_password}
              onChange={handleChange}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShowPassword1(!showPassword1)}>
                      {showPassword1 ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                )
              }}
            />

            <TextField
              label="Confirmar contraseña"
              type={showPassword2 ? "text" : "password"}
              fullWidth
              margin="normal"
              name="confirm_password"
              value={form.confirm_password}
              onChange={handleChange}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShowPassword2(!showPassword2)}>
                      {showPassword2 ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                )
              }}
            />

            <Button type="submit" variant="contained" fullWidth className="login-button">
              GUARDAR CONTRASEÑA
            </Button>

            <Box textAlign="center" mt={2}>
              <Typography
                variant="body2"
                className="login-link"
                onClick={() => navigate("/login")}
                style={{ cursor: "pointer", fontWeight: "bold" }}
              >
                Volver al login
              </Typography>
            </Box>
          </form>
        </Container>
      </div>
    </div>
  );
};

export default UpdatePasswordPage;